<app-dialog #dialog
            (cancel)="cancelButtonClicked()"
            (confirm)="logOutButtonClicked()"
            cancelButtonText="Cancel"
            confirmButtonText="Log Out"
            [title]=title>
</app-dialog>
